import styled from 'styled-components'

type Props = {
  transform?: number
}

export const Container = styled.div<Props>`
  display: flex;
  align-items: center;
  width: 2.5rem;
  position: relative;

  > svg {
    position: absolute;
    left: -1.5rem;
    transform: ${(props) =>
      props.transform ? `rotate(${props.transform}deg)` : null};
  }
`
